<h2 mat-dialog-title>
  Checkout
</h2>





<mat-dialog-content class="mat-typography row  d-flex justify-content-center">


  <div class="table-responsive mb-4">
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Nombre</th>
          <th scope="col">Precio</th>
          <th scope="col">Cantidad</th>
          <th scope="col">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor=" let ticket of this.data.ticketsBuy">
          <td>{{ticket.name}}</td>
          <td>{{ticket.price}}</td>
          <td>{{ticket.quantitie}}</td>
          <td>{{ticket.quantitie *ticket.price}}</td>
        </tr>

        <tr>
          <td>Total Final</td>
          <td></td>
          <td></td>
          <td>{{totalFinal}}</td>
        </tr>

      </tbody>
    </table>

  </div>

  <button mat-raised-button class="col-12" color="warn" (click)="checkout()">
    <mat-icon>shopping_cart</mat-icon> Ir a pagar


  </button>



</mat-dialog-content>



<mat-dialog-actions align="end">

  <button mat-button type="button" (click)="closeDialog(false)">Cerrar</button>
</mat-dialog-actions>